import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditUserProductionDetailType extends TermCreateEdit {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "user_production_detail_type";
  }
}
